module.exports = __webpack_public_path__ + "img/sv1.a8b32f7.png";